var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"AmataTabsItem",class:{ 'is-active': _vm.isActive },on:{"click":_vm.onClicked}},[_c('a',{staticClass:"AmataTabsItem__a"},[(_vm.label)?[_vm._v(_vm._s(_vm.label))]:_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }